import React, { useEffect } from 'react';
import { useLocation, Navigate, useNavigate } from 'react-router-dom';
import CardForm from '../components/CardForm';
import { alertModal } from '../utils/modalController';
import Loader from '../components/Loader';
import { fetchAuth } from '../utils/fetchAuth';

const apiUrl = process.env.REACT_APP_API_URL || '';

interface Props {
    loading?: boolean;
}

const ResetPassword: React.FC<Props> = ({ loading }) => {
    const [userName, setUserName] = React.useState<string | null>(null);
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const continueTo = searchParams.get('continue');
    const token = searchParams.get('token');
    const id = searchParams.get('id');

    const navigate = useNavigate();

    useEffect(() => {
        // Verifica se o token e o id estão presentes
        if (!token || !id) {
            console.error('Token ou ID ausente na URL');
            return;
        }

        fetch(`${apiUrl}/login/validate-token?token=${token}&id=${id}`)
            .then(async (response) => {
                if (!response.ok) {
                    const errorData = await response.json();
                    return Promise.reject(new Error(errorData.message || 'Erro ao validar token'));
                }
                return response.json();
            })
            .then((data) => {
                setUserName(data.data?.userName || null);
            })
            .catch(async (err) => {
                console.error('Erro ao validar token:', err);
                await alertModal('Erro ao validar token: ' + err);

                navigate('/login/esqueci-senha');
            })
            .finally(() => {
                // Aqui você pode definir o estado de loading como false se necessário
            });
    }, [token, id]);

    if (loading) return <Loader />;

    if (!token || !id) {
        return <Navigate to="/login/esqueci-senha" replace />;
    }

    return (
        <CardForm
            id='forgot-password'
            title="Recupere sua senha"
            action={`${apiUrl}/login/reset-password`}
            method="POST"
            fields={[
                { name: 'email', type: 'email', label: 'Email', disabled: true },
                { name: 'password', type: 'password', label: 'Nova Senha', required: true },
                { name: 'password-confirm', type: 'password', label: 'Confirme a Nova Senha', required: true },
                { name: 'userLinkToken', type: 'hidden', label: 'Token de Redefinição' },
                { name: 'userLinkId', type: 'hidden', label: 'ID do token' },
            ]}
            defaultValues={{ email: userName || '', userLinkToken: token || '', userLinkId: id || '' }}
            link={{ label: 'Voltar ao login', url: '/login' + (continueTo ? `?continue=${encodeURIComponent(continueTo)}` : '') }}
            submitLabel="Criar Senha"
            onSubmit={async (formData, action, method) => {
                const formElement = document.getElementById('form-forgot-password') as HTMLFormElement;

                if (!formElement) throw new Error('Formulário não encontrado');


                // <- comportamento padrão (form encoded + fetch)
                const body = new URLSearchParams();
                for (const key in formData) {
                    const value = formData[key];
                    if (Array.isArray(value)) {
                        value.forEach(v => body.append(key, v));
                    } else {
                        body.append(key, value);
                    }
                }

                const response = await fetchAuth(action, {
                    method,
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: method === 'POST' ? body.toString() : undefined,
                });

                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.message || 'Erro ao redefinir senha');
                }

                const responseData = await response.json();
                console.log('Response Data:', responseData);


                formElement.querySelectorAll('.mb-3, button')?.forEach((el) => {
                    (el as HTMLElement).style.display = 'none';
                });

                return {
                    message: responseData.message || 'Verifique seu email para redefinir sua senha.',
                    errorCode: 0,
                }
            }}
        />
    );
}

export default ResetPassword;
